<mat-drawer-container>
  <mat-drawer #drawer mode="side">
    @if (mainNavigation(); as nav) {
      <div class="title">
        <h3>{{ current()?.label ?? nav.label }}</h3>
      </div>
      <ui-toggle-navigation
        [navigationRoot]="nav"
        [selectedItem]="current()"
        (selectionChange)="$event.children ? current.set($event) : drawer.close()"
        (navigationChange)="drawer.close()"
        [topLevelTiles]="!current()?.parent"
      ></ui-toggle-navigation>

    }
  </mat-drawer>

  <mat-drawer-content>
    <button (click)="drawer.toggle()" mat-fab>
      <ui-icon [faName]="drawer.opened ? 'chevron-left' : 'bars'" faStyle="light"></ui-icon>
    </button>
  </mat-drawer-content>
</mat-drawer-container>
